import React, { useContext } from "react";
import Card from "../components/Card";
import { ThemeContext } from "../themeProvider";
import ShpperiaStore from '../assets/ShopperiaStore.png';
import ChatApp from '../assets/ChatApp.png';
import MoviesApp from '../assets/MoviesApp.png';
// import TravelDestination from '../assets/TravelDestination.png';
import Sooqna from '../assets/sooqna.png';

const Projects = () => {
  const theme = useContext(ThemeContext);
  const darkMode = theme.state.darkMode;
  const projects = [
    {
      name: 'Sooqna',
      summary: 'an online platform that facilitates consumer-to-consumer sales through its website',
      image: Sooqna,
      url: 'https://sooqna-front-end.vercel.app/',
      github: 'https://github.com/Full-Stack-Squad-js02/Sooqna-FrontEnd'
    },
    {
      name: 'Shopperia Store',
      summary: 'an online storefront that will allow our users to browse our product offerings by category, place items in their shopping cart, and check-out when they are ready to make their purchase',
      image: ShpperiaStore,
      url: 'https://storefront-one-lime.vercel.app/',
      github:'https://github.com/EsraaBanat/storefront'
    },
    {
      name: 'Chat App',
      summary: ' an online communication app that enables you and your website visitors to chat in real-time. All you or your visitors need to do is to type the message inside the chatbox and send it',
      image: ChatApp,
      url: 'https://chat-app-lime-two.vercel.app/',
      github: 'https://github.com/EsraaBanat/Chat_App'
    },
    {
      name: 'Movies App',
      summary: 'an app that show latest versions of movies and the user can add any movie to favorite list',
      image: MoviesApp,
      url: 'https://magusmovie.netlify.app/',
      github: 'https://github.com/Magus-team-js/Netflix-Clone'
    }
  ]
  return (
    <div
      id="projects"
      className={darkMode ? "bg-white text-black" : "bg-gray-900 text-white"}
    >
      <div className="max-w-7xl mx-auto x-4 sm:px-6 lg:px-8 px-4  pt-24 pb-12">
        <h2 className="text-5xl font-bold px-4 md:px-0 text-center">
          Projects
        </h2>
        <h4 className="mt-16 text-3xl font-semibold text-blue-600 ">
          What I Built
        </h4>
        <div className="mt-8 flex justify-between items-stretch flex-wrap">
          {
            projects.map((project, idx) => {
              return (
                <Card key={idx} name={project.name} summary={project.summary} image={project.image} url={project.url} github={project.github} />
              )
            })}
        </div>
        {/* <a
          href="hello"
          className=" w-32 flex items-center py-4 px-4 text-sm font-medium text-center text-white bg-blue-700 rounded-lg hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800 mx-auto mt-4"
        >
          Show More
          <svg
            className="ml-2 -mr-1 w-4 h-4"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
              clipRule="evenodd"
            ></path>
          </svg>
        </a> */}
      </div>
    </div>
  );
};

export default Projects;
